var React = require('react');

function Checkmark (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.31 15.3l-1.974-.022-1.848-7.625 2.079-.63 1.113 5.355h.126A57.014 57.014 0 0 1 11.328.7l2.184.965A72.1 72.1 0 0 0 6.31 15.3z"}));
}

Checkmark.defaultProps = {"id":"Layer_1","height":"16","viewBox":"0 0 16 16","width":"16"};

module.exports = Checkmark;

Checkmark.default = Checkmark;
